// extracted by mini-css-extract-plugin
module.exports = {"root":"CompleteLink_root__WEq5F","rootSuccess":"CompleteLink_rootSuccess__1nOzh","rootFailure":"CompleteLink_rootFailure__oUQAi","isDisabled":"CompleteLink_isDisabled__6-lLi"};